import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { TableColumn } from '../../../Component/Model/Table/Table';
import { VAClientData } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { Typography } from '@mui/material';

interface VAClientRow {
  VAClientId: number;
  CompanyName: ILinkProps;
  VATNumber?: string;
  RegistrationNumber?: string;
  ReferenceNumber?: string;
  ScorecardCount: string;
}

interface ILinkProps {
  itemId: number;
  itemName: string;
}

export interface VAClientTable {
  columns: Array<TableColumn>;
  rows: Array<VAClientRow>;
}

export function VAClientTableMapper(dataObject: VAClientData[], setCompany: (id: number, name:string, registrationNumber:string, vatNumber:string) => void): VAClientTable {
  const columns = [
    { Header: 'Company Name', accessor: 'CompanyName', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" style={{cursor:"pointer"}} onClick={() => setCompany(value.itemId, value.itemName, value.itemRegistrationNumber, value.itemVatNumber)}>{value.itemName}</Typography> },
    { Header: 'Client Reference Number', accessor: 'ReferenceNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Registration Number', accessor: 'RegistrationNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'VATNumber', accessor: 'VATNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Number Of Linked Scorecards', accessor: 'ScorecardCount', Cell: ({ value }: any) => <DefaultCell value={value} /> }
  ];
  if (dataObject !== undefined && dataObject.length > 0){
    const rows = dataObject.map((item: VAClientData, index: number) => ({
      VAClientId: item.vaClientId,
      CompanyName: { itemId: item.vaClientId, itemName: item.companyName, itemRegistrationNumber: item.registrationNumber, itemVatNumber: item.vatNumber },
      ReferenceNumber: item.referenceNumber,
      VATNumber: item.vatNumber,
      RegistrationNumber: item.registrationNumber,
      ScorecardCount: item.scorecardCount
    }));
    return { columns: columns, rows: rows };
  }
  else {
    return { columns: columns, rows: [] };
  }
}

